// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2a91f","modalFooterButton":"ModalNotes_modalFooterButton__FKfvv"};